/**
 * Discount-bearing fields of a receipt summary, in cents.
 *
 * Lives here rather than beside the Receipt class so consumers that only hold a serialized
 * receipt (Receipt.toJSON(), or a receipt read back off an order) can share this definition
 * without importing shared/order/receipt.js, which pulls in big.js and order/utilities.
 */
export type ReceiptDiscountSummary = {
  discounts?: number | null;
  mixAndMatch?: number | null;
  rewards?: number | null;
  incentives?: number | null;
};

/**
 * Total value taken off a receipt by every discount mechanism, in cents: product and
 * order-level discounts (coupons land here), BOGO/mix-and-match, loyalty rewards, and
 * payment incentives. Returns null when there is no summary to read or the sum is
 * non-finite, so callers can distinguish "no receipt" from a genuine zero.
 */
export const sumReceiptDiscountsInCents = (summary: ReceiptDiscountSummary | null | undefined): number | null => {
  if (summary == null) return null;

  const total =
    Number(summary.discounts ?? 0) +
    Number(summary.mixAndMatch ?? 0) +
    Number(summary.rewards ?? 0) +
    Number(summary.incentives ?? 0);

  return Number.isFinite(total) ? total : null;
};
